<template>
  <div class="researcher-picture">
    <!-- render avatar missing -->
    <label for="newFile" class="mb-0 lbl-missing" v-if="!hasAvatar()">
      <avatar-missing :name="getFullName(researcher)"
        :editable="canEdit"
        :containerClass="`pull-left clickable`">
      </avatar-missing>
    </label>

    <!-- add avatar -->
    <avatar v-if="hasAvatar()"
      :editable="canEdit"
      :avatar="user.avatar"
      :name="getFullName(researcher)"
      @open="openModal">
    </avatar>

    <!-- hidden input when user has no image -->
    <input v-if="!hasAvatar() && canEdit"
      type="file"
      name="newFile"
      id="newFile"
      class="btn-input-file"
      accept="image/png, image/jpeg, image/gif, image/jpg"
      @change="uploadImage($event)"
    >

    <!-- render upload-picture -->
    <upload-picture v-if="showModal && canEdit"
      :image="image"
      :newImage="file"
      @closed="showModal = false"
      @updated="updateAvatar">
    </upload-picture>
  </div>
</template>

<script>
import AvatarMissing from '@/components/shared/AvatarMissing'
import Avatar from '@/components/shared/Avatar'
import UploadPicture from '@/components/user/avatar/UploadPicture'

export default {
  name: 'userAvatar',
  components: {
    AvatarMissing,
    Avatar,
    UploadPicture
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    researcher: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      image: '',
      file: null,
      showModal: false
    }
  },
  mounted () {
    this.$events.$on('user:avatar:open', (url) => { this.openModal(url) })
    this.$events.$on('user:avatar:upload', (e) => { this.uploadImage(e) })
  },
  computed: {
    url () {
      return `${process.env.VUE_APP_S3_URL}`
    },
    canEdit () {
      return this.$can.edit('researcher', this.user.rw_access)
    }
  },
  methods: {
    uploadImage (e) {
      this.file = e
      this.showModal = true
    },
    openModal (url) {
      if (this.user.avatar) {
        this.showModal = true
        this.image = url
      }
    },
    hasAvatar () {
      return !!this.user.avatar
    },
    updateAvatar (key, value) {
      if (value === null) value = ''
      this.image = value
      this.$events.$emit('user:avatar:changed', value)
      this.$events.$emit('user:updated', key, value)
    }
  },
  destroyed () {
    this.$events.$off('user:avatar:open')
    this.$events.$off('user:avatar:upload')
  }
}
</script>
